import CircularProgress from '@material-ui/core/CircularProgress';
import {Button, Container, Form} from 'react-bootstrap';
import {makeStyles} from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import React, {memo, useState} from 'react';
import {lvUploadAPI} from '../API/lvupload';
import validator from 'validator/es';
import '../Styles/LVhochladen.css';
import $ from 'jquery';
import '../index.css';
import {uploadLVS3API} from "../API/uploadLV";
import moment from 'moment'
import { deleteLV, getParsedData, getProject } from '../API/analysenrequestdata';
import { getUserInfo, sendEmail } from '../API/user';

function LVhochladen() {
	const [formData, setFormData] = useState({
		proj_name: '',
		submissionTermin: '',
		vertragsStart: '',
		vertragsEnde: '',
		s3uploadURL:''
	});
	const [errorMessage, setErrorMessage] = useState({
		projectName: '',
		gaebFileName: '',
		vhb211FileName: '',
		vhb213FileName: '',
		vhb214FileName: '',
		efb221FileName: ''
	});
	
	const [s3UploadSuccess, setS3UploadSuccess] = useState(false)
	
	/**
	 * Function formats the date to required structure of date. Example: 2020-02-20
	 * @param date
	 * @returns {string}
	 */
	function formatDate(date) {
		let dd = String(date.getDate()).padStart(2, '0'); // Always 2 digits. Example: 01
		let mm = String(date.getMonth() + 1).padStart(2, '0');
		let yyyy = date.getFullYear();
		date =  dd + "." + mm + "." + yyyy;
		return date;
	}
	
	// Get today's date and set it as min date for Submission Termin
	let today = new Date();
	today = formatDate(today);
	
	const [submissionTerminStartDate, setSubmissionTerminStartDate] = useState(today);
	const [vertragStartDate, setVertragStartDate] = useState(submissionTerminStartDate);
	
	// The Project File Name check is set to false because it is not optional.
	const [isProjectNameCheck, setProjectNameCheck] = useState(false);
	
	// The GAEB File check is set to false because it is not optional.
	const [isGAEBCheck, setIsGAEBCheck] = useState(false);
	
	// The following checks are set to true because they are optional.
	const [isVHB211Check, setIsVHB211Check] = useState(true);
	const [isVHB213Check, setIsVHB213Check] = useState(true);
	const [isVHB214Check, setIsVHB214Check] = useState(true);
	const [isEFB221Check, setIsEFB221Check] = useState(true);
	
	const useStyles = makeStyles((theme) => ({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff'
		}
	}));
	
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	
	const handleClick = async () => {
		// Circle Loading Animation - Starts
		setIsLoading(true);

		if (isProjectNameCheck && isGAEBCheck && isVHB211Check && isVHB213Check && isVHB214Check && isEFB221Check) {

			let data = new FormData();
			let filename = document.getElementById('GAEBfileUploadID').files[0].name
			data.append('gaeb', document.getElementById('GAEBfileUploadID').files[0]);
			//data.append('vhb211', document.getElementById('vhb211fileUploadID').files[0]);
			//data.append('vhb213', document.getElementById('vhb213fileUploadID').files[0]);
			//data.append('vhb214', document.getElementById('vhb214fileUploadID').files[0]);
			//data.append('efb221', document.getElementById('efb221fileUploadID').files[0]);
			data.append('proj_name', formData.proj_name);
			data.append('submissionTermin', formData.submissionTermin);
			data.append('vertragsStart', formData.vertragsStart);
			data.append('vertragsEnde', formData.vertragsEnde);
			data.append('s3uploadURL', formData.s3uploadURL);
			let today_date = moment().format('DD.MM.YYYY')
			data.append("upload_date",today_date)
			console.log("data is",Object.fromEntries(data))
			console.log("filename is",filename)




			// API Call - sending data to backend
			let responseStatus = await lvUploadAPI(data, formData.proj_name, filename)
			if (responseStatus === "success") {
				$('#upload-lv').trigger('reset');

				let userData = await getUserInfo();

				const uploaded_lv_id = formData.s3uploadURL.split("/")[1]
				const just_uploaded_proj = await getProject(uploaded_lv_id);
				const parserData = await getParsedData(just_uploaded_proj.result);

				if (parserData.status !== 200) {

					deleteLV({ uid: uploaded_lv_id, s3url: formData.s3uploadURL });

					const emailDetails = {
						emailtype: "lv_parse_failure",
						emaildetails: {
							email: userData.em,
							username: userData.fn,
							projectname: formData.proj_name
						}
					};
					sendEmail(emailDetails);

					alert("Das LV wurde im falschen Dateiformat hochgeladen.\nDie Analyse kann basierend auf dem GAEB-Format 83 durchgeführt werden.");

					formData['s3uploadURL'] = '';
					setFormData({...formData});

					setIsLoading(false);
					return;
				}

				// Circle Loading Animation - Stops
				setIsLoading(false);
				alert("Das Leistungsverzeichnis wurde erfolgreich hochgeladen und für die Analyse vorbereitet.")

				let lv_uploaded_email_details = {
					emailtype: "uploadlv",
					emaildetails: {
						email: userData.em,
						username: userData.fn,
						projectname: formData.proj_name
					}
				}

    			sendEmail(lv_uploaded_email_details);

				formData['s3uploadURL'] = '';
				setFormData({...formData});
			} else {
				// Circle Loading Animation - Stops
				setIsLoading(false);
				alert("Bitte erneut versuchen")
			}
		} else {
			alert('bitte überprüfen nochmal die data geben');
		}
	};
	
	/***
	 * Function validates the rule, "Only A-Z, a-z, 0-9 are allowed characters for every field and files."
	 * @param value
	 * @returns boolean - true / false
	 */
	function isValid(value) {
		let receivedValue = value.trim();
		let rsl = false;
		
		//File name check for valid length to avoid server crash due to long path generated
		if (receivedValue.length < 50) {
			rsl = true;
			receivedValue.split(/(?:[_ -])+/).forEach((word) => {
				rsl = rsl && validator.isAlphanumeric(word, 'de-DE');
			});
		}
		return rsl;
	}
	
	/***
	 * Function updates the respetive file keys with validation flag and also error message.
	 * @param fileNameKey
	 * @param condition
	 * @param message
	 */
	function updateValidationFlags(fileNameKey, condition, message) {
		switch (fileNameKey) {
			case 'gaeb':
				setIsGAEBCheck(condition);
				setErrorMessage({...errorMessage, gaebFileName: message});
				break;
			case 'vhb211':
				setIsVHB211Check(condition);
				setErrorMessage({...errorMessage, vhb211FileName: message});
				break;
			case 'vhb213':
				setIsVHB213Check(condition);
				setErrorMessage({...errorMessage, vhb213FileName: message});
				break;
			case 'vhb214':
				setIsVHB214Check(condition);
				setErrorMessage({...errorMessage, vhb214FileName: message});
				break;
			case 'efb221':
				setIsEFB221Check(condition);
				setErrorMessage({...errorMessage, efb221FileName: message});
				break;
		}
	}
	
	/***
	 * Function validates the lv-upload form.
	 */
	function isFormValid() {
		return (
			isProjectNameCheck &&
			isGAEBCheck &&
			isVHB211Check &&
			isVHB213Check &&
			isVHB214Check &&
			isEFB221Check &&
			formData.submissionTermin !== '' &&
			formData.vertragsStart !== '' &&
			formData.vertragsEnde !== '' &&
			formData.s3uploadURL!==''&&
			s3UploadSuccess
		);
	}
	
	/***
	 * Function validates the uploaded file and stores in Form Data.
	 * @param fileNameKey
	 * @param event
	 */
	async function validateFile(fileNameKey, event) {
		let message =
			'Bitte überprüfen Sie den Dateinamen. ' +
			'Nur Buchstaben A-Z, a-z, Zahlen 0-9 und "-", "_" sind ' +
			'zulässig. Maximal 50 Zeichen.';
		
		const selectedFile = event.target.files;
		if (selectedFile.length === 0) {
			// If no file is selected
			setFormData({...formData, [fileNameKey]: ''});
			updateValidationFlags(fileNameKey, false, '');
			return;
		}
		let fileName = selectedFile[0].name;
		
		//S3 Info
		let lvFileName = fileName
		let lvFile = selectedFile[0]
		
		// Retrieve the file name excluding the file extension
		let lastIndex = fileName.lastIndexOf('.');
		const fileExt = fileName.substr(lastIndex);
		fileName = fileName.substr(0, lastIndex);

		if (!['.d83', '.x83', '.p83'].includes(fileExt.toLowerCase())) {
			let userData = await getUserInfo();
			const emailDetails = {
				emailtype: "lv_parse_failure",
				emaildetails: {
					email: userData.em,
					username: userData.fn,
					projectname: formData.proj_name
				}
			};
			sendEmail(emailDetails);
			message = "Bitte überprüfen Sie den Dateityp. Es werden nur die Dateitypen x83, d83 und p83 unterstützt.";
			updateValidationFlags(fileNameKey, false, message);
			return;
		}

		if (isValid(fileName)) {
			// Once file name is validated, check the file size is within allowed limits.
			let fileSize = selectedFile[0].size;
			let fileSizeMB = fileSize / 1024 / 1024;
			if (fileSizeMB <= 70) {
				setFormData({...formData, [fileNameKey]: selectedFile});
				updateValidationFlags(fileNameKey, true, '');
				
				// Upload file to S3
				let s3ResponseCode = await uploadLVS3API(lvFileName, lvFile)
				if (s3ResponseCode.httpStatusCode === 200) {
					setS3UploadSuccess(true)
					console.log(s3ResponseCode.S3URL,22222)
					setFormData({...formData,s3uploadURL: s3ResponseCode.S3URL
					});

					return
				} else {
					console.log("check s3 upload")
				}
			}
			message = 'Die Dateigröße darf 70 MB nicht überschreiten.';
		}
		updateValidationFlags(fileNameKey, false, message);
	}
	
	return (
		<>
			<div className="handwai-dark borderStyle">
				<Container fluid>
					{isLoading ? (
						<Backdrop className={classes.backdrop} open>
							<CircularProgress color="inherit"/>
						</Backdrop>
					) : (
						''
					)}
					
					<div className="handwai-dark handwai-text-label-normal">
						<Form id="upload-lv">
							<Form.Group controlId="formGroupNameDesProjekts">
								<Form.Label>
									Name des Projekts <span className="errorStyle">*</span>
								</Form.Label>
								<Form.Control
									type="text"
									placeholder="Name des Projekts"
									required
									aria-required="true"
									className="handwai-input"
									style={addWidth555}
									onChange={(event) => {
										//Validate project name
										if (isValid(event.target.value)) {
											setFormData({...formData, proj_name: event.target.value});
											setErrorMessage({...errorMessage, projectName: ''});
											setProjectNameCheck(true);
										} else {
											setProjectNameCheck(false);
											setErrorMessage({
												...errorMessage,
												projectName:
													'Bitte überprüfen Sie den Projektnamen. ' +
													'Nur Buchstaben A-Z, a-z, Zahlen 0-9 und "-", "_" sind ' +
													'zulässig. Maximal 50 Zeichen.'
											});
										}
									}}
								/>{' '}
								<p className="errorStyle">{errorMessage.projectName} </p>
							</Form.Group>
							<br/>
							<Form.Group controlId="formGroupSubmissionDate">
								<Form.Label>
									Submissionstermin <span className="errorStyle">*</span>
								</Form.Label>
								<Form.Control
									type="date"
									min={submissionTerminStartDate}
									className="handwai-input"
									style={addWidth555}
									onChange={(event) => {
										let eventValue = event.target.value;
										let date = new Date(eventValue);
										date = formatDate(date);
										setSubmissionTerminStartDate(date);
										setVertragStartDate(date);
										setFormData({
											...formData,
											submissionTermin: date
										});
									}}
								/>
							</Form.Group>
							<br/>
							<Form.Group controlId="formGroupVertragsstartDate">
								<Form.Label>
									Vertragsstart <span className="errorStyle">*</span>
								</Form.Label>
								<Form.Control
									type="date"
									min={submissionTerminStartDate}
									className="handwai-input"
									style={addWidth555}
									onChange={(event) => {
										let eventValue = event.target.value;
										let date = new Date(eventValue);
										date = formatDate(date);
										setVertragStartDate(date);
										setFormData({...formData, vertragsStart: date});
									}}
								/>
							</Form.Group>
							<br/>
							<Form.Group controlId="formGroupVertragsendeDate">
								<Form.Label>
									Vertragsende <span className="errorStyle">*</span>
								</Form.Label>
								<Form.Control
									type="date"
									min={vertragStartDate}
									className="handwai-input"
									style={addWidth555}
									onChange={(event) =>
									{
										let eventValue = event.target.value;
										let date = new Date(eventValue);
										date = formatDate(date);
										setFormData({
											...formData,
											vertragsEnde: date
										})
									}
									}
								/>
							</Form.Group>
							<p className="errorStyle">{errorMessage.fileName} </p>
							<br/>
							<Form.Group controlId="GAEBfileUploadID">
								<Form.Label>
									83 GAEB-Datei hochladen <span className="errorStyle">*</span>
								</Form.Label>
								<Form.File
									accept=".x83, .d83, .p83"
									onChange={(event) => {
										validateFile('gaeb', event);
									}}
								/>
							</Form.Group>
							<p className="errorStyle">{errorMessage.gaebFileName} </p>
							<br/>
							<br/>
							<Button
								disabled={!isFormValid()}
								onClick={handleClick}
								className="handwai-btn-login"
								variant="success"
								size="lg"
								block
							>
								HOCHLADEN
							</Button>
							<br/>
						</Form>
					</div>
				</Container>
			</div>
		</>
	);
}

const addWidth555 = {
	width: 555
};

export default memo(LVhochladen);